export interface BibliographyTagRegisterData {
  tag: string
  data: string
  marcTag?: string
}

export function BibliographyTagRegisterDataToJSON(
  json: BibliographyTagRegisterData
): any {
  return {
    tag: json.tag,
    data: json.data,
    marc_tag: json.marcTag
  }
}
